import styled from 'styled-components';
import { colors } from '../../globalStyles';

export const modalStyle = {
  overlay: {
    background: 'rgba(60, 60, 60, 0.8)',
  },
  content: {
    border: `1px solid ${colors.border}`,
    background: colors.white,
    borderRadius: '4px',
    outline: 'none',
    padding: '20px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    maxHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    '@media only screen and (maxWidth: 1025px)': {
      margin: '15px 5px',
      padding: '0',
      overflow: 'scroll',
      height: '100vh',
    },
  },
};

export const ModalContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: '5px',
  padding: '0 20px',
  width: '450px',
  margin: '0px 20px',
  '@media only screen and (maxWidth: 1025px)': {
    margin: '15px 5px',
    padding: '0',
    height: '100vh',
    justifyContent: 'center',
  },
});

export const ModalCloseButton = styled.a({
  position: 'absolute',
  top: '20px',
  right: '20px',
  width: '30px',
  height: '30px',
  color: colors.green,
  cursor: 'pointer',
  '&:hover': {
    color: `${colors.darkGreen}!important`,
    textDecoration: 'none',
    opacity: 0.8,
  },
  '&:focus': {
    color: `${colors.darkGreen}!important`,
    textDecoration: 'none',
    opacity: 0.8,
  },
});

export const UpgradeModalNowLabel = styled.p({
  fontSize: '20px',
  color: colors.green,
  lineHeight: '0px',
  marginTop: '30px',
});

export const UpgradeModalPriceLabel = styled.h2({
  color: colors.green,
  lineHeight: '0px',
  marginBottom: '40px',
});

export const NoB2cDiv = styled.div({
  marginBottom: '20px',
  fontSize: '14px !important',
});
